import {SummaryModel} from "../../../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../../../common/entity/permissions.model";
import {LovValueSummary} from "../../../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {Moment} from "moment";
import {TreatmentJourneyStepTriggerModel} from "./treatmentJourneyStepTrigger.model";
import {ValueAndLabelModel} from "../../../../../../../common/model/valueAndLabel.model";
export class TreatmentJourneyStepSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    start: Moment;
    end: Moment;
    label: string;
    visibleInExternalApplication: boolean;
    trigger: TreatmentJourneyStepTriggerModel;
    type: LovValueSummary;
    errors: ValueAndLabelModel[]= [];
}